{
  "remove": "Odstrani"
}
